import { Alert, AlertTitle } from '@mui/material'
import React, { memo } from 'react'

const CustomAlert = ({ severity, title, desc, onClose, size, sx, icon }) => {
  return (
    <Alert
      severity={severity}
      sx={{ width: '100%', ...sx }}
      onClose={onClose}
      size={size}
      icon={icon}
    >
      <AlertTitle>{title}</AlertTitle>
      {desc}
    </Alert>
  )
}

export default memo(CustomAlert)
